<script lang="ts">
import SuperAdminLayout from "@/layouts/SuperAdminLayout.vue"

export default { layout: SuperAdminLayout }
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList, SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import FlashAlerts from "@/components/FlashAlerts.vue"
import { pluralize } from "@/lib/format"
import { superAdminAccountPath } from "@/routes"
import type { AccountListEntry } from "@/types/models"

defineProps<{
  accounts: AccountListEntry[]
}>()
</script>

<template>
  <Head title="Accounts — Admin" />

  <div class="flex flex-col gap-6">
    <FlashAlerts />

    <SbList v-if="accounts.length" bordered separator>
      <SbListItem
        v-for="account in accounts"
        :key="account.id"
        :to="superAdminAccountPath(account.id)"
      >
        <SbListSection>
          <SbListLabel>{{ account.name }}</SbListLabel>
          <SbListLabel caption>{{ account.owners }}</SbListLabel>
        </SbListSection>
        <SbListSection side>
          <div class="flex items-center gap-4 text-sm">
            <span class="text-muted">{{ pluralize(account.items_count, "item") }}</span>
            <span class="text-muted">{{ pluralize(account.members_count, "member") }}</span>
          </div>
        </SbListSection>
      </SbListItem>
    </SbList>

    <p v-else class="text-muted py-12 text-center text-sm">No accounts yet.</p>
  </div>
</template>
